(() => {
  const form = document.querySelector('[data-copper-cart]');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const drawer = form.closest('#CartDrawer');
  const content = form.querySelector('[data-cc-content]');
  const error = form.querySelector('[data-cc-error]');
  const base = form.dataset.cartUrl.replace(/\/$/, '');
  let busy = false, stale = false, refreshPending = false, scheduled;
  const state = () => JSON.parse(content.querySelector('[data-cc-state]').textContent);
  const recommendationStorageKey = 'miriam-cart-last-product';
  let lastAddedProduct = '';
  let explicitAddition = false;
  try { lastAddedProduct = sessionStorage.getItem(recommendationStorageKey) || ''; } catch (_) {}
  let knownProductIds = new Set(state().items.map(item => String(item.product_id)));
  function rememberAdded(result) {
    const items = result?.items || (result ? [result] : []);
    const item = items.find(item => item.product_id && !item.gift_card && String(item.product_id) !== String(state().warrantyId));
    if (!item) return;
    explicitAddition = true;
    lastAddedProduct = String(item.product_id);
    try { sessionStorage.setItem(recommendationStorageKey, lastAddedProduct); } catch (_) {}
  }
  function selectRecommendations(body, next) {
    const templates = Array.from(body.querySelectorAll('template[data-cc-rec-product]'));
    const availableIds = new Set(templates.map(template => template.dataset.ccRecProduct));
    const newItem = next.items.find(item => !knownProductIds.has(String(item.product_id)) && availableIds.has(String(item.product_id)));
    if (!availableIds.has(lastAddedProduct)) {
      lastAddedProduct = newItem ? String(newItem.product_id) : (templates[0]?.dataset.ccRecProduct || '');
    } else if (!explicitAddition && newItem) {
      lastAddedProduct = String(newItem.product_id);
    }
    explicitAddition = false;
    knownProductIds = new Set(next.items.map(item => String(item.product_id)));
    const selected = templates.find(template => template.dataset.ccRecProduct === lastAddedProduct);
    const host = body.querySelector('[data-cc-recommendations-host]');
    if (host) host.replaceChildren(...(selected ? [selected.content.cloneNode(true)] : []));
    try {
      if (lastAddedProduct) sessionStorage.setItem(recommendationStorageKey, lastAddedProduct);
      else sessionStorage.removeItem(recommendationStorageKey);
    } catch (_) {}
  }

  function lock(value) {
    busy = value; form.setAttribute('aria-busy',String(value));
    form.querySelectorAll('[data-cc-change],[data-cc-add],[data-cc-warranty],.cc-checkout').forEach(el => el.disabled = value || (stale && el.matches('.cc-checkout')));
  }
  function fail(message) {
    error.textContent = message + ' ';
    const link = document.createElement('a');link.href = base;link.textContent = 'View cart';error.append(link);error.hidden = false;
  }
  async function request(path, body) {
    const response = await fetch(path,{method:body ? 'POST' : 'GET',credentials:'same-origin',cache:'no-store',headers:body ? {'Content-Type':'application/json','Accept':'application/json'} : {'Accept':'application/json'},...(body ? {body:JSON.stringify(body)} : {})});
    let result;try { result = await response.json(); } catch (_) { throw Error('Unable to confirm the cart. Check your cart before trying again.'); }
    if (!response.ok || result.status) throw Error(typeof result.description === 'string' ? result.description : result.message || 'Unable to update your cart.');
    if (body && path.split('?')[0].endsWith('/add.js')) rememberAdded(result);
    return result;
  }
  function warrantyUpdates(cart,warrantyId) {
    const warrantyItems = cart.items.filter(i => String(i.product_id) === String(warrantyId));
    const hasMerchandise = cart.items.some(i => String(i.product_id) !== String(warrantyId) && i.quantity > 0);
    const updates = {};
    warrantyItems.forEach((item,index) => { const quantity = hasMerchandise && index === 0 ? 1 : 0; if(item.quantity !== quantity) updates[item.key] = quantity; });
    return updates;
  }
  async function normalize() {
    const cart = await request(base+'.js');
    const updates = warrantyUpdates(cart,state().warrantyId);
    if(Object.keys(updates).length) await request(base+'/update.js',{updates});
  }
  async function render(focus) {

    const terms = form.querySelector('[data-cc-terms]')?.checked;
    const scroll = content.querySelector('.cc-scroll')?.scrollTop || 0;
    const oldBar = content.querySelector('.cc-meter > span');
    const previousWidth = oldBar?.style.width;
    const response = await fetch(base+'?view=copper-drawer&_='+Date.now(),{credentials:'same-origin',cache:'no-store'});
    if(!response.ok) throw Error('The cart could not be refreshed.');
    const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
    const body = parsed.querySelector('[data-cc-render]');
    if(!body?.querySelector('[data-cc-state]')) throw Error('The cart could not be refreshed.');
    const incomingState = JSON.parse(body.querySelector('[data-cc-state]').textContent);
    selectRecommendations(body, incomingState);
    content.replaceChildren(body);
    const newBar = content.querySelector('.cc-meter > span');
    if(newBar && previousWidth && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const targetWidth = newBar.style.width;
      newBar.style.transition = 'none';newBar.style.width = previousWidth;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if(newBar.isConnected) { newBar.style.transition = '';newBar.style.width = targetWidth; }
      }));
    }
    const next = state();
    form.querySelector('[data-cc-count]').textContent = next.count;
    document.querySelectorAll('.cart-link__bubble-num').forEach(el=>el.textContent=next.count);
    document.querySelectorAll('.cart-link__bubble').forEach(el=>el.classList.toggle('cart-link__bubble--visible',next.count>0));
    if(content.querySelector('.cc-scroll')) content.querySelector('.cc-scroll').scrollTop = scroll;
    if(terms && form.querySelector('[data-cc-terms]')) form.querySelector('[data-cc-terms]').checked = true;
    stale = false;
    lock(false);
    if(focus && drawer.classList.contains('drawer--is-open')) {
      const target = Array.from(form.querySelectorAll('[data-focus]')).find(el=>el.dataset.focus===focus);
      (target || form).focus({preventScroll:true});
    }
  }
  async function perform(action) {
    if(busy) return;
    const focus = document.activeElement?.dataset?.focus;
    error.hidden = true;lock(true);
    try { if(action) { stale = true;await action(); } await normalize();await render(focus); }
    catch(e) { try { await render(focus); } catch (_) { stale = true; } fail(e.message || 'Unable to update your cart. Check your cart before trying again.'); }
    finally { lock(false);if(refreshPending){refreshPending=false;queueRefresh();} }
  }
  function queueRefresh() {
    if(busy){refreshPending=true;return;}
    clearTimeout(scheduled);scheduled=setTimeout(()=>perform(),0);
  }
  form.addEventListener('click',event=>{
    const change = event.target.closest('[data-cc-change]');
    const add = event.target.closest('[data-cc-add]');
    const scroll = event.target.closest('[data-cc-scroll]');
    if(change){event.preventDefault();perform(()=>request(base+'/change.js',{id:change.dataset.key,quantity:Number(change.dataset.ccChange)}));}
    if(add){event.preventDefault();const select=add.closest('.cc-rec').querySelector('[data-cc-variant]');perform(()=>request(base+'/add.js',{items:[{id:select?.value || add.dataset.ccAdd,quantity:1}]}));}
    if(scroll){const track=form.querySelector('.cc-rec-track');track.scrollBy({left:Number(scroll.dataset.ccScroll)*(track.clientWidth+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  });
  form.addEventListener('change',event=>{
    const input=event.target;
    if(input.matches('[data-cc-warranty]')){
      const checked=input.checked;input.checked=!checked;
      perform(async()=>{
        const current=await request(base+'.js');
        const id=state().warrantyId;
        const warrantyItems=current.items.filter(i=>String(i.product_id)===String(id));
        if(checked){
          if(!current.items.some(i=>String(i.product_id)!==String(id))) throw Error('Add a product before selecting the warranty.');
          if(!warrantyItems.length) await request(base+'/add.js',{items:[{id:input.dataset.ccWarranty,quantity:1}]});
        } else if(warrantyItems.length){await request(base+'/update.js',{updates:Object.fromEntries(warrantyItems.map(i=>[i.key,0]))});}
      });
    }
    if(input.matches('[data-cc-variant]')) input.closest('.cc-rec').querySelector('[data-cc-rec-price]').textContent=input.selectedOptions[0].dataset.price;
    if(input.matches('[data-cc-note]')) perform(()=>request(base+'/update.js',{note:input.value}));
  });
  form.addEventListener('submit',event=>{if(busy||stale){event.preventDefault();fail('Please wait for the cart to refresh before checking out.');}});
  document.addEventListener('ajaxProduct:added', event => {
    rememberAdded(event.detail?.product);
    queueRefresh();
  });
  ['cart:updated','cart:build','drawerOpen.CartDrawer'].forEach(name=>document.addEventListener(name,queueRefresh));
  // Reconcile a warranty-only cart or duplicate warranty quantities on load.
  queueRefresh();
})();


